// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".build-badge[data-v-adbade90]{background:rgba(48,48,48,.75);border-radius:0 0 4px 4px;color:#fff;font-family:monospace;font-size:10px;left:50%;line-height:1.5;max-width:calc(100vw - 16px);overflow:hidden;padding:0 6px;pointer-events:none;position:fixed;text-overflow:ellipsis;top:0;transform:translateX(-50%);white-space:nowrap;z-index:9999}.build-badge.is-feature-branch[data-v-adbade90]{background:rgba(230,110,0,.92)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
